module.exports = __webpack_public_path__ + "img/02.6ceaa6c1.jpg";